var team = {};
module['exports'] = team;
team.creature = require("./creature");
team.name = require("./name");